export default [
    {
        field: 'gender',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Genero',
        },
        //value: 30,
        options: {
            data: [
                {
                    id: 'M',
                    gender: 'Masculino',
                },
                {
                    id: 'F',
                    gender: 'Femenino',
                },
            ],
            text: 'gender',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'has_subsidy_young_worker',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Subsidio Empleo Joven',
        },
    },
    {
        field: 'g_civil_status_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Estado civil',
        },
        //value: 30,
        options: {
            data: [],
            text: 'description',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'hr_previred_employee_type_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Previred',
        },
        //value: 30,
        options: {
            data: [],
            text: 'description',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'hr_previred_nationality_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Nacionalidad',
        },
        //value: 30,
        options: {
            data: [],
            text: 'description',
            value: 'id',
        },
        rules: ['required'],
    },
    
    {
        field: 'family_assignment_average_incoming',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Promedio Renta 6 meses',
        },
        rules: ['required'],
        value: '',
    },
    
]
